import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  Typography,
  Grid,
  Box,
  useMediaQuery,
  Skeleton,
  Paper,
  Avatar,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import CommonButton from "../../Components/InputComponents/CommonButton";
import { decryptId } from "../../Components/CryptoComponent";

const ClientCandidateProfile = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width: 1220px)");

  const fromLocation = location?.state?.from;

  const paginationState = location?.state?.pagination || {
    page: 0,
    rowsPerPage: 25,
  };
  const filterData = location?.state?.filterData || {
    name: "",
    profession: "",
    jobapplication: "",
    jobid: "",
    interviewdate: "",
  };
  const candidateData = location?.state?.selectedId;

  const [personalDetails, setPersonalDetails] = useState({
    Name: "",
    Date_Of_Birth: "",
    Passport_Number: "",
    Address: "",
    Profession: "",
    Designation: "",
    Years_of_Experience: "",
    Department_1: "",
    Department_2: "",
    Department_3: "",
    Last_working_Date: "",
    Career_Gap: "",
    Registration_License: "",
    Registration_Expiry: "",
    Photo: "",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    const data = JSON?.parse(candidateData);
    setPersonalDetails({
      Name: data?.CI_Name,
      Date_Of_Birth: data?.CI_Dateofbirth,
      Passport_Number: data?.CI_PassportNo,
      Address: data?.CI_Address,
      Profession: data?.Applied_profession_Name,
      Designation: data?.CI_Designation,
      Years_of_Experience: data?.CI_YearofExp,
      Department_1: data?.CI_Department1,
      Department_2: data?.CI_Department2,
      Department_3: data?.CI_Department3,
      Last_working_Date: data?.CI_Last_working_date,
      Career_Gap: data?.CI_CareerGap,
      Registration_License: data?.CI_Registration_License,
      Registration_Expiry: data?.CI_Registration_License_expry,
      Photo: data?.CI_Photo,
    });
  }, [candidateData]);

  return (
    <Paper
      sx={{
        maxWidth: `100vw`,
        padding: 2,
        margin: "auto",
        boxShadow: "none",
        overflowX: "auto",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          mb: 2,
          gap: 2,
        }}
      >
        <CommonButton
          variant="outlined"
          background="#006CB8"
          onClick={() =>
            navigate(
              fromLocation == "Jobs" ? `/Candidates` : `/DeployedCandidates`,
              {
                state: {
                  pagination: paginationState,
                  filterData: filterData,
                },
              }
            )
          }
          margin="0px 20px 10px 0px"
        >
          <ArrowBackIcon sx={{ color: "white" }} />
        </CommonButton>

        <Typography
          variant="h5"
          sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
        >
          Candidate Details
        </Typography>
      </Box>

      {/* Profile + Name Section */}
      <Grid
        container
        spacing={2}
        alignItems="center"
        justifyContent={{ xs: "center", sm: "flex-start" }}
        sx={{ mb: 2 }}
      >
        <Grid item>
          <Avatar
            src={`${process.env.REACT_APP_BASE_URL}/${personalDetails.Photo}`}
            sx={{
              width: 140,
              height: 140,
              borderRadius: "50%",
              objectFit: "cover",
              border: "3px solid #ccc",
              boxShadow: 2,
              mx: "auto",
            }}
          >
            {personalDetails?.Name ? personalDetails?.Name[0] : ""}
          </Avatar>
        </Grid>

        <Grid item>
          <Typography
            variant="h6"
            sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
          >
            {personalDetails?.Name || "-"}
          </Typography>
          <Typography sx={{ fontFamily: "Geist, sans-serif" }} variant="body1">
            {personalDetails?.Profession || "-"}
          </Typography>
          <Typography
            sx={{ fontFamily: "Geist, sans-serif" }}
            variant="body2"
            color="text.secondary"
          >
            Passport No: {personalDetails?.Passport_Number || "-"}
          </Typography>
        </Grid>
      </Grid>

      {/* Personal Details */}
      <Grid container spacing={2}>
        <Grid item xs={12} id="personalDetailsSection">
          <Box
            sx={{
              border: "2px solid lightgrey",
              p: 3,
              borderRadius: 2,
            }}
          >
            <Box
              sx={{
                backgroundColor: "#f5f5f5",
                borderRadius: 2,
                px: 2,
                py: 1,
                mb: 2,
              }}
            >
              <Typography
                variant="h6"
                sx={{ fontWeight: 600, fontFamily: "Geist, sans-serif" }}
              >
                Personal Details
              </Typography>
            </Box>

            <Grid container spacing={2}>
              {Object.entries(personalDetails)
                ?.filter(([key]) => key !== "Photo")
                ?.map(([key, value]) => (
                  <Grid item xs={12} sm={6} md={6} lg={6} xl={4} key={key}>
                    <Box>
                      <Typography
                        sx={{
                          fontWeight: 600,
                          fontSize: "18px",
                          mb: 0.5,
                          fontFamily: "Geist, sans-serif",
                        }}
                      >
                        {key.replace(/_/g, " ")}
                      </Typography>
                      {value ? (
                        <Typography
                          sx={{
                            fontWeight: 400,
                            fontSize: "16px",
                            fontFamily: "Geist, sans-serif",
                          }}
                        >
                          {value}
                        </Typography>
                      ) : (
                        "-"
                      )}
                    </Box>
                  </Grid>
                ))}
            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ClientCandidateProfile;
